/** 라이더 공지사항 */
export default class WorkerNotice {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    /** 작성자 */
    _userName = '';
    get userName() {
        return this._userName;
    }
    set userName(value) {
        this._userName = value;
    }
    _createdAt = 0;
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    _selectedWorkerList = [];
    get selectedWorkerList() {
        return this._selectedWorkerList;
    }
    set selectedWorkerList(value) {
        this._selectedWorkerList = value;
    }
    _noticeStart = 0;
    get noticeStart() {
        return this._noticeStart;
    }
    set noticeStart(value) {
        this._noticeStart = value;
    }
    _noticeEnd = 0;
    get noticeEnd() {
        return this._noticeEnd;
    }
    set noticeEnd(value) {
        this._noticeEnd = value;
    }
    /** 라이더 대상 타입 */
    _workerNoticeTargetType = '';
    get workerNoticeTargetType() {
        return this._workerNoticeTargetType;
    }
    set workerNoticeTargetType(value) {
        this._workerNoticeTargetType = value;
    }
    /** 공지사항 타입
     ORDER_CANCEL("A1", "주문취소"),
     ALLOCATE_CANCEL("A2", "배차취소"),
     IMMEDIATE_ALLOCATE("A3", "즉시배차"),
     ORDER_MODIFY("A4", "주문수정"),
     MESSAGE("B1", "메시지"),
     NOTICE_OR_ELSE("XX", "공지사항")
    */
    _notiTitleType = '';
    get notiTitleType() {
        return this._notiTitleType;
    }
    set notiTitleType(value) {
        this._notiTitleType = value;
    }
    /** 대상 허브 */
    _hub = null;
    get hub() {
        return this._hub;
    }
    set hub(value) {
        this._hub = value;
    }
    /** 작성 기간 */
    _noticePeriodType = '';
    get noticePeriodType() {
        return this._noticePeriodType;
    }
    set noticePeriodType(value) {
        this._noticePeriodType = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(_data) {
        // 맵핑 변경
        const { workers, ...data } = _data;
        return {
            ...data,
            selectedWorkerList: workers,
        };
    }
}
